<template>
  <div class="container mb052">

    <breadcrumb-group :items="breadcrumbItems"/>

    <repayment-simulation :member="true">
      <btn-main class="-main" slot="nextBtn" routerName="mb001">
        会員さま専用サイトトップへ
      </btn-main>

    </repayment-simulation>

  </div><!-- container -->
</template>

<script>
import RepaymentSimulation from '../components/simulation/RepaymentSimulation'
import HeadingTwo from '../components/heading/HeadingTwo'
import CardLink from '../components/card/CardLink'
import BtnMain from '../components/button/BtnMain'
export default {
  name: 'Mb-052',
  metaInfo: {
    title: 'ご返済シミュレーション | ご返済',
    meta: [
      {name: 'description', content: 'お客さまに合った毎月のご返済プランがシミュレーションできます。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ご返済シュミレーション'}
    ]
  },
  components: {
    BtnMain,
    CardLink,
    HeadingTwo,
    RepaymentSimulation
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: 'ご返済シミュレーション',
        active: true
      }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";

</style>



// WEBPACK FOOTER //
// src/pages/Mb052.vue